import * as Colors from 'ui-library/Colors';

export const ANALYSIS_FLOWCHART_NODE_HEIGHT = 70;
export const ANALYSIS_FLOWCHART_NODE_WIDTH = 180;

export const ANALYSIS_FLOWCHART_EDGE_LABEL_HEIGHT = 20;
export const ANALYSIS_FLOWCHART_EDGE_LABEL_WIDTH = 160;

export const ANALYSIS_FLOWCHART_BACKGROUND = Colors.GRAY_LIGHTER;
export const ANALYSIS_FLOWCHART_NODE_COLOR = Colors.WHITE;
export const ANALYSIS_FLOWCHART_NODE_ERROR_COLOR = Colors.RED_LIGHT;
